import { Token, TokenBU, TokenField, TokenResponse } from "./token";

export class Payload{
    bu: TokenBU;
    token: Token;
    field: TokenField;
    response: TokenResponse;
}
